import { useNavigate } from 'react-router-dom';
import ForgetForm from '../../components/Forget';
import { emailRegex } from '../../components/Login';
import { usePasswordOTPMutation } from '../../services/auth';
import TokenManager from '../../utils/tokenManager';
import * as routes from '../../pages/routes';
import MockUp from '../Register/mockUp';
import handleSubmitError from '../../utils/authErrors';
import { OTP_DESCRIPTION, OTP_TITLE, OTPType } from '@/constants/authOtp';

const ForgetContainer = () => {
  const initialValues = {
    username: ''
  };
  const navigate = useNavigate();

  const [sendOtp, { isLoading, isSuccess }] = usePasswordOTPMutation();

  const handleOnSubmit = (values: { username: string | number }) => {
    sendOtp({ phone_number: values.username.toString() })
      .unwrap()
      .then((res) => {
        // The code goes where the username points: an email gets the email wording, not "number".
        const username = values.username.toString();
        const otpType: OTPType = emailRegex.test(username.trim())
          ? 'email'
          : 'sms';
        const highlight = {
          email: username,
          sms: username.replace(/(\d{4})(\d{3})(\d{2})(\d{2})/g, '$1 $2 $3 $4'),
          ga: 'Google Authenticator'
        };
        // Only authorises the reset steps: held in memory, never stored as a session.
        TokenManager.setPending(res.data.accessToken);
        navigate(routes.OTP, {
          state: {
            username: values.username,
            title: OTP_TITLE[otpType],
            description: OTP_DESCRIPTION[otpType],
            highlight: highlight[otpType],
            from: 'forget',
            type: otpType
          }
        });
      })
      .catch(handleSubmitError);
  };

  return (
    <>
      <ForgetForm
        initialValues={initialValues}
        onSubmit={handleOnSubmit}
        isLoading={isLoading || isSuccess}
      />
      <MockUp />
    </>
  );
};

export default ForgetContainer;
